/* eslint-disable @typescript-eslint/ban-ts-comment */
import { addModal, closeCurrentModal } from 'weblite-web-modal-viewer'
import { ChooseGroupCall } from './choose-group-call'
import { GroupCallType } from '$logic/call'

const COMPONENT_ID = 'chooseGroupCall'

const showChooseGroupCall = (props: Parameters<typeof ChooseGroupCall>[0]) =>
  addModal({ id: COMPONENT_ID, props })

export const showChooseGroupCallDialog = (): Promise<GroupCallType> =>
  new Promise((resolve, reject) =>
    showChooseGroupCall({
      onConfirm: async callType => {
        await closeCurrentModal()
        resolve(callType)
      },
      onCancel: async () => {
        await closeCurrentModal()
        reject()
      },
    }),
  )

export default {
  [COMPONENT_ID]: {
    Component: ChooseGroupCall,
  },
}
